import { Wallet } from 'lucide-react';
import { Link } from 'react-router-dom';

const APP_VERSION = '1.0.0';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2 text-green-600 font-semibold">
            <Wallet className="w-5 h-5" />
            <span>ExpenseEasy</span>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-gray-500">
            <Link to="/" className="hover:text-green-600 transition-colors">Home</Link>
            <Link to="/login" className="hover:text-green-600 transition-colors">Sign In</Link>
          </div>
          <div className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} ExpenseEasy &mdash; v{APP_VERSION}
          </div>
        </div>
      </div>
    </footer>
  );
}
